<template>
    <section id="Home">
        <div>
            <!-- <div class="container mt-5">
                <div class="row d-block d-md-flex justify-content-start align-items-center">
                    <div class="col">
                        <AnimatedHeadline />
                        <div class="mt-3">
                            <h5 class="d-none d-md-block text-start fw-bold">The Agricultural Value Chain Simplified </h5>
                            <h6 class="d-md-none text-start fw-bold">The Agricultural Value Chain Simplified </h6>
                        </div>
                    </div>
                    <div class="col mt-5 mt-md-0">
                        <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1791667546/website-bg.png" class="img-fluid" alt="...">
                    </div>
                </div>
            </div> -->
            <div id="carouselHero" class="carousel slide carousel-fade" data-bs-ride="carousel">
                <div v-if="loading" class="carousel-container d-flex justify-content-center align-items-center p-5">
                    <div className="spinner-border text-white m-5 p-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">            
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Guaranteed & Quality</span>
                                <br />
                                <span class="subtitle">Poultry Production</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792097861/truck.jpg" 
                                class="d-block h-100 " alt="...">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Replacing Ghana's Imported Chicken<br />With a Technology Powered</span>
                                <br />
                                <span class="subtitle">Smallholder Poultry Production Ecosystem</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792168212/broiler.jpg"
                                class="d-block h-100" alt="...">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Train And Support</span>
                                <br />
                                <span class="subtitle">Young Female<br />Smallholder Farmers</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792097860/distribution.jpg"
                                    class="d-block h-100" alt="...">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Fresh, Quality & Wholesome</span>
                                <br />
                                <span class="subtitle">Chicken Marketplace</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792097861/processed.jpg"
                                class="d-block h-100" alt="...">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Digital Innovation For</span>
                                <br />
                                <span class="subtitle">Climate Smart Farming</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792097864/farm.jpg"
                                class="d-block h-100" alt="...">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="6000">
                        <div class="carousel-container row flex-nowrap">
                            <div class="col-12 col-md-6 align-self-end align-self-md-center title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span class="fs-1">Contribute To Global</span>
                                <br />
                                <span class="subtitle">Global Security</span>
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
                                <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1792097861/warehouse.jpg"
                                class="d-block h-100" alt="...">
                            </div>
                        </div>
                    </div>
                    <!-- <div class="carousel-item">
                        <div class="carousel-container">
                            <img src="https://res.cloudinary.com/dp9w9miha/image/upload/v1680024935/YOUTH_and_WOMEN_EMP_copy_e614da47f8.jpg"
                                class="d-block img-fluid" alt="...">
                            <div class="title animate__animated animate__fadeInLeft text-start px-5 py-5">
                                <span>YOUTH AND WOMEN</span>
                                <br />
                                <span style="color:#ffb2c0; font-size: 60px;">EMPOWERMENT</span>
                            </div>
                        </div>
                    </div> -->
                </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselHero"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselHero"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
            </div>
        </div>
        

        <!-- <svg class="Home-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28 " preserveAspectRatio="none">
            <defs>
                <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g class="wave1">
                <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
            </g>
            <g class="wave2">
                <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
            </g>
            <g class="wave3">
                <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
            </g>
        </svg> -->

    </section>
</template>

<script>
import { getLocalContent } from '@/data/strapi';
import { carouselEndpoint } from '@/endpoint/endpoint';
import AnimatedHeadline from '@/components/headline/Animated-Headline.vue';

export default {
    name: "Carousel-large",
    components: {
        AnimatedHeadline    
    },

    data () {
        return {
            carousels: [],
            loading: true,
        }
    },

    mounted () {
        this.getCarousels();
    },

    methods: {
        async getCarousels(){
            try{
                const response = await getLocalContent(carouselEndpoint)
                const results = response?.data?.data
                this.carousels.push(results)
                if (response) {
                    this.loading = false
                }


            } catch(error) {
                    console.error(error)
                    this.loading = true
                }
        }
    }
}
</script>

<style scoped>
#Home {
    background: #fff;
}

#Home .carousel-container {
    text-align: center;
    position: relative;
}

#Home img {
    z-index: 0;
}

#Home .title {
    z-index: 1;
    left: 0;
    line-height: 1;
    margin-left: 110px;
}

#Home .title .subtitle {
    color: #3db49d;
    font-size: 60px;
    letter-spacing: -0.1rem;
}

#Home span {
    font-size: 50px;
    font-weight: 900;
}

.btn-get-started {

    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    text-decoration: none;
    display: inline-block;
    padding: 12px 32px;
    border-radius: 5px;
    transition: 0.3s;
    line-height: 1;
    color: #fff;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    margin-top: 6px;
    border: 2px solid #fff;
}

.btn-get-started:hover {
    background: #fff;
    color: #2a2c39;
    text-decoration: none;
}

@media (max-width: 750px) { 
    #Home .title {
        margin-left: 0;
        background: rgba(255, 255, 255, 0.894);
    }
    #Home .title .subtitle {
        
    }
}
@media (max-width: 1300px) { 
    #Home .title {
        background: rgba(255, 255, 255, 0.894);
    }
}


/* @media (min-height: 1366px) {
    #Home .carousel-container {
        position: relative;
        padding-top: 60px;
    }
} */

@media (max-width: 1024px) {
    /* #Home .carousel-container {
        height: 75vh;
    } */

    #Home .carousel-control-prev,
    #Home .carousel-control-next {
        width: 10%;
        text-decoration: none;
    }

    /* #Home span {
        font-size: 28px;
    } */
}

@media (max-width: 1300px) {
    /* #Home .carousel-container {
        height: 65vh;
    } */

    #Home .carousel-control-prev,
    #Home .carousel-control-next {
        width: 10%;
        text-decoration: none;
    }

    /* #Home span {
        font-size: 28px;
    } */
}

/* .Home-waves {
    display: block;
    width: 100%;
    height: 60px;
    z-index: 10;
    bottom: 0;
    position: absolute;
}

.wave1 use {
    -webkit-animation: move-forever1 10s linear infinite;
    animation: move-forever1 10s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

.wave2 use {
    -webkit-animation: move-forever2 8s linear infinite;
    animation: move-forever2 8s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

.wave3 use {
    -webkit-animation: move-forever3 6s linear infinite;
    animation: move-forever3 6s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

@-webkit-keyframes move-forever1 {
    0% {
        transform: translate(85px, 0%);
    }

    100% {
        transform: translate(-90px, 0%);
    }
}

@keyframes move-forever1 {
    0% {
        transform: translate(85px, 0%);
    }

    100% {
        transform: translate(-90px, 0%);
    }
}

@-webkit-keyframes move-forever2 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@keyframes move-forever2 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@-webkit-keyframes move-forever3 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@keyframes move-forever3 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
} */
</style>